import { FC, ReactNode } from 'react'

import { Cluster, Skeleton, Stack, Typography } from '@forto-dev/phoenix-ui-core'

type DashboardSectionProps = {
  title: string
  description: string
  action?: ReactNode
  children: ReactNode
}

export const DashboardSection: FC<DashboardSectionProps> = ({ title, description, action, children }) => {
  const heading = (
    <Stack>
      <Typography variant="h4">{title}</Typography>
      <Typography variant="small" color="muted">
        {description}
      </Typography>
    </Stack>
  )

  return (
    <Stack gap={16}>
      {action ? (
        <Cluster gap={16} x="between" y="end" fullWidth>
          {heading}
          <Cluster x="end" y="end">
            {action}
          </Cluster>
        </Cluster>
      ) : (
        heading
      )}
      {children}
    </Stack>
  )
}

export const DashboardSectionHeadingSkeleton: FC = () => (
  <Stack gap={4}>
    <Skeleton variant="content" />
    <Skeleton variant="badge" fullWidth />
  </Stack>
)
